module.exports = __webpack_public_path__ + "img/3.de365127.png";